export const SIGNUP_SOURCE_OPTIONS = [
  'Author recommendation',
  'Conference or writing event',
  'Podcast',
  'Webinar',
  'Facebook or social media',
  'Google or web search',
  'Newsletter or email',
  'Publishing professional',
  'Other',
] as const;

export type SignupSource = (typeof SIGNUP_SOURCE_OPTIONS)[number];

const SIGNUP_SOURCE_SET = new Set<string>(SIGNUP_SOURCE_OPTIONS);
const SOURCES_WITH_DETAIL = new Set<SignupSource>([
  'Conference or writing event',
  'Podcast',
  'Webinar',
]);

export const sanitizeSignupSource = (value: unknown): SignupSource | undefined => {
  if (typeof value !== 'string') {
    return undefined;
  }
  const normalized = value.trim();
  return SIGNUP_SOURCE_SET.has(normalized) ? (normalized as SignupSource) : undefined;
};

export const signupSourceAcceptsDetail = (value: unknown): boolean => {
  const source = sanitizeSignupSource(value);
  return Boolean(source && SOURCES_WITH_DETAIL.has(source));
};

export const sanitizeSignupSourceDetail = (
  source: unknown,
  detail: unknown,
): string | undefined => {
  if (!signupSourceAcceptsDetail(source) || typeof detail !== 'string') {
    return undefined;
  }
  const normalized = detail.trim().replace(/\s+/g, ' ').slice(0, 200);
  return normalized || undefined;
};
